import { EBL_DCSATemplate } from "./EBL_DCSA/EBL_DCSATemplate";
import { ExternalTransportDocumentTemplate } from "./ExternalTransportDocument/ExternalTransportDocumentTemplate";

export const registry = {
  EBL_DCSA: EBL_DCSATemplate,
  EXTERNAL_TRANSPORT_DOCUMENT: ExternalTransportDocumentTemplate
};
